/**
 * @generated SignedSource<<fbd8376c4b9201eb5b5836796a284bca>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedProductTileCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemTilesCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedProductTileCarousel_viewer";
};
export type PdpSharedProductTileCarousel_viewer$key = {
  readonly " $data"?: PdpSharedProductTileCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedProductTileCarousel_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "fetchFavorites",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTilesCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "362fcdc717db6e748bb917cc16ccb87b";

export default node;
